export default "__VITE_ASSET__DgISF8AQ__"